import React from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import styled from 'styled-components';
import { LocationSuggestion } from './utils';
import { AddressValue } from './Locations';
import LocationSearchRow from './LocationSearchRow';

const StyledDiv = styled.div`
  .heading-label-text {
    margin-bottom: 0px;
  }
  .no-matches-found {
    padding-bottom: 10px;
    padding-left: 5px;
  }
  .loading {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .heading-margin-top {
    margin-top: 12px;
  }
`;

type LocationProps =
  | {
      loading: false;
      suggestions: LocationSuggestion;
    }
  | {
      loading: true;
      suggestions?: undefined;
    };

const Loading: React.FC = () => {
  return (
    <StyledDiv>
      <LocationSearchRow loading={true} className="loading" />
      <LocationSearchRow loading={true} className="loading" />
      <LocationSearchRow loading={true} className="loading" />
      <LocationSearchRow loading={true} className="loading" />
      <LocationSearchRow loading={true} className="loading" />
    </StyledDiv>
  );
};
interface LocationSearchResultProps {
  selectedAddresses: AddressValue[];
  handleAdd: (address: AddressValue) => unknown;
  handleRemove: (index: number) => unknown;
}

const LocationSearchResult: React.FC<LocationSearchResultProps &
  LocationProps> = ({
  loading,
  suggestions,
  selectedAddresses,
  handleAdd,
  handleRemove,
}) => {
  if (loading) {
    return <Loading />;
  }
  return (
    <StyledDiv>
      {suggestions.all.length === 0 ? (
        <TrueImpactText variant="body-small" className="no-matches-found">
          No addresses were found.
        </TrueImpactText>
      ) : (
        suggestions.all.map((c, i) => {
          const index = selectedAddresses.findIndex(
            x => x.address === c.address,
          );
          return (
            <LocationSearchRow
              suggestion={c}
              key={c.address || i}
              handleAdd={handleAdd}
              handleRemove={handleRemove}
              loading={false}
              index={index}
              selected={index !== -1}
            />
          );
        })
      )}
    </StyledDiv>
  );
};

export default LocationSearchResult;
